import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteTask as DeleteTaskMutation,
    DeleteTaskVariables,
    TaskDeleteInput,
} from 'nutshell-graphql-types';

import {nutApolloClient} from '../../../../../../apollo-client';
import CORE_ENTITY_TASK_FRAGMENT from '../../../../graphql/fragments/core-entity-task-fragment.graphql';

import {removeTaskFromCaches} from '../helpers/remove-task-from-caches';
import DELETE_TASK from '../mutations/delete-task.graphql';

export const useDeleteTask = (): {
    deleteTask: (arg1: TaskDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deleteTask, {loading, error}] = useMutation<DeleteTaskMutation, DeleteTaskVariables>(
        DELETE_TASK
    );

    return {
        deleteTask: (input: TaskDeleteInput) => {
            const cachedTask = nutApolloClient.readFragment({
                id: input.task,
                fragmentName: 'CoreEntityTaskFragment',
                fragment: CORE_ENTITY_TASK_FRAGMENT,
            });

            return deleteTask({
                variables: {input},
                optimisticResponse: cachedTask
                    ? {
                          taskDelete: {
                              __typename: 'TaskDeletePayload',
                              task: cachedTask,
                          },
                      }
                    : undefined,
                update: (proxy) =>
                    cachedTask && removeTaskFromCaches(proxy, input.task, cachedTask),
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
